import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentage',
})
export class PercentagePipe implements PipeTransform {
  transform(value: number | string): string {
    const emptyValue = '';
    return value ? `${value} %` : emptyValue;
  }
}
